import React, { useState, useEffect } from 'react';
import './UserApp.css';
import SimpleScan from './SimpleScan';
import UserRequests from './UserRequests';

const UserApp = () => {
  const [activeTab, setActiveTab] = useState('scan'); // 'scan' ou 'requests'

  useEffect(() => {
    const handleSwitchToScan = () => {
      setActiveTab('scan');
    };

    window.addEventListener('switchToScan', handleSwitchToScan);
    return () => {
      window.removeEventListener('switchToScan', handleSwitchToScan);
    };
  }, []);

  return (
    <div className="user-app">
      <div className="user-nav">
        <button 
          className={`nav-tab ${activeTab === 'scan' ? 'active' : ''}`}
          onClick={() => setActiveTab('scan')}
        >
          📷 Scanner
        </button>
        <button 
          className={`nav-tab ${activeTab === 'requests' ? 'active' : ''}`}
          onClick={() => setActiveTab('requests')}
        >
          📋 Mes demandes
        </button>
      </div>
      
      <div className="user-content">
        {activeTab === 'scan' ? <SimpleScan /> : <UserRequests />}
      </div>
    </div>
  );
};

export default UserApp;

